/**
 * Countries held back from the site (sitenopk, 4 Oct 2026; founder: hide
 * Pakistan for now). A bare list in a file of its own, because routes.tsx sits
 * in the app's first load and must carry nothing more than this.
 * siteCountries.ts builds the site's country list from it.
 */
export const HIDDEN_ON_SITE: readonly string[] = ['PK'];
